import React from 'react';
import { Link } from 'react-router-dom';

import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

const images = [
	{
		original: 'assets/images/user/car-dealers/a.jpg',
		thumbnail: 'assets/images/user/car-dealers/a.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/b.jpg',
		thumbnail: 'assets/images/user/car-dealers/b.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/c.jpg',
		thumbnail: 'assets/images/user/car-dealers/c.jpg',
	},
	{
		original: 'assets/images/user/car-dealers/d.jpg',
		thumbnail: 'assets/images/user/car-dealers/d.jpg',
	},
];

export default function TaxiCarsPost() {
	return (
		<div>
			<div class='main-content-area'>
				<div class='container'>
					<p class='mb-5 text-center'>
						<a class='btn btn-warning btn-lg' href='#' role='button'>
							<i class='fas fa-paper-plane'></i> POST
						</a>
					</p>

					<div class='row'>
						<div class='col-12 col-sm-12 col-md-7 col-lg-7 mb-2 mb-sm-2 mb-md-2 mb-lg-0'>
							<div class='bxslider'>
								<ImageGallery items={images} class='img-fluid' />
								{/* <div><img src="assets/images/user/car-dealers/a.jpg" alt="" class="img-fluid"/></div>
						<div><img src="assets/images/user/car-dealers/b.jpg" alt="" class="img-fluid"/></div>
						<div><img src="assets/images/user/car-dealers/c.jpg" alt="" class="img-fluid"/></div>
						<div><img src="assets/images/user/car-dealers/d.jpg" alt="" class="img-fluid"/></div> */}
							</div>
						</div>
						<div class='col-12 col-sm-12 col-md-5 col-lg-5 d-flex align-items-end'>
							<div class='w-100'>
								<h3 class='mb-0'>Johanthan Alison</h3>
								<p style={{ color: 'green' }}>Available</p>

								<p>
									We are an innovative mobile auto service that is the ideal way
									to save your time on all of your tire maintenance needs,. From
									tire changeovers for small cars to SUV, to Oil Filter Change,
									Battery & Brake trimming. Garage has got you covered.
								</p>

								<div class='car-details-block'>
									<div class='row'>
										<div class='col-12'>
											<div class='car-details-block-horizontal'>
												<div class='row'>
													<div class='col-4'>
														<div class='line-a'>Car</div>
														<div class='line-b'>Honda City</div>
													</div>
													<div class='col-4'>
														<div class='line-a'>Type</div>
														<div class='line-b'>Sedan</div>
													</div>
													<div class='col-4'>
														<div class='line-a'>Plate</div>
														<div class='line-b'>77463</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class='car-agent-cwm'>
									<div class='row'>
										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/telephone.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												Call
											</a>
										</div>

										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/whatsapp.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												Whatsapp
											</a>
										</div>

										<div class='col-4'>
											<a
												class='btn btn-outline-secondary btn-block'
												href='#'
												role='button'>
												<img
													src='assets/images/icons/user/car-dealers/map.svg'
													alt=''
													class='icon-cwm'
												/>{' '}
												5 KM
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
